// Run polyfills first
import 'embed/polyfills'
// Run DataDog RUM init next
import 'embed/services/Datadog/RUM'

import 'iframe-resizer'

import * as React from 'react'
import { Provider } from 'react-redux'
import { Action, createStore } from 'redux'

import { useTheme } from 'embed/hooks'
import { middleware } from 'embed/middleware'

import BrowserStateLoader from 'embed/components/BrowserStateLoader/container'
import ConfigProvider from 'embed/components/ConfigProvider'
import { GoogleFontsClient } from 'embed/components/GoogleFontsClient'
import { ErrorBoundary } from 'embed/components/ErrorBoundary'
import AppContainer from 'embed/components/App/container'
import GlobalStyles from 'embed/components/GlobalStyles'
import ViewportSizeProvider from 'embed/components/ViewportSizeProvider'
import { ThemeProvider } from 'embed/components/ThemeProvider'
import { initQueryParamsFromWindow } from 'ui/multi-product/utils/query-params'

import reducers, { initialMultiProductState, MultiProductState } from 'embed/reducers'

import { GoogleTagManager } from 'embed/services/GoogleTagManager'
import Session from 'embed/services/Session'
import Tracker, { setupTracker } from 'embed/services/Tracker'

import './styles'
import { UI_NAME } from 'embed/constants'

// Publish GA events to the parent service
GoogleTagManager.publishToParent = true

const store = createStore<MultiProductState, Action<unknown>, {}, {}>(reducers, initialMultiProductState, middleware)

export type StoreType = typeof store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Let session use dispatch as a notification bus
Session.dispatch = store.dispatch

const Embed = () => {
  React.useEffect(() => {
    setupTracker(Tracker, UI_NAME, store)
    initQueryParamsFromWindow()
  }, [])

  const { fontFamilyPrimary, fontFamilySecondary } = useTheme()
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider>
          <GoogleFontsClient fonts={[fontFamilyPrimary, fontFamilySecondary]} />
          <BrowserStateLoader>
            <ConfigProvider waitForParentConfig={true}>
              <ViewportSizeProvider />
              <GlobalStyles />
              <AppContainer />
            </ConfigProvider>
          </BrowserStateLoader>
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  )
}

export default Embed
